import invoke from '../utils/invoke';
import config from '../config.json';

export const findPathIfExist = (key) => {
    return invoke({
        url :   `${config.SERVER_END_POINT}/v1/api/search/${key}`,
        method  :   'GET'
    })
}